const controller = '/language'
export default axios => ({
  translateText(obj) {
    return axios.post(`${controller}/translate`, obj)
  },
})
